import React, { Fragment } from 'react';
// components
import { FormattedMessage, useIntl } from 'react-intl';
import FilterSectionWrapper from '../FilterSectionWrapper';
import CheckboxMenu from '../Menu/CheckboxMenu';
import Select from 'components/Select';
import { ReactComponent as FarmIcon } from 'icons/farm.svg';
// types
import { CountryBornSectionType, UserFilterSectionProps } from 'types/filterSections';
import { OptionKeysTypes } from 'components/Select/Select.types';
// utils, hooks
import useFilterSectionState from 'utils/hooks/useFilterSectionState';

function getCountryBornOptions(formatMessage: (obj: { id: string }) => string) {
  return [
    {
      value: 'none',
      label: formatMessage({ id: 'general.countryBorn.none' }),
    },
    {
      value: 'usa',
      label: formatMessage({ id: 'general.countryBorn.usa' }),
    },
    {
      value: 'canada',
      label: formatMessage({ id: 'general.countryBorn.canada' }),
    },
  ];
}

const CountryBornSection = ({
  conditions,
  isDisabled,
  labelKeys,
  onOptionSelect,
  onRemove,
  section,
}: UserFilterSectionProps<CountryBornSectionType>) => {
  const { formatMessage } = useIntl();
  const COUNTRY_BORN_OPTIONS = getCountryBornOptions(formatMessage);
  const { condition, isInitialOpened, isInvalid, options } = section;
  const sectionText = options?.[0]?.value || '';
  const { state, handleConditionChange, handleValueChange, resetData } = useFilterSectionState(
    sectionText,
    condition
  );
  const { text, value } = state;
  const isConditionWithOptions = ['eq', 'not_eq'].includes(value);

  const handleApply = () => {
    if (value) {
      onOptionSelect(
        value,
        isConditionWithOptions ? [{ key: 'country_born', value: text }] : undefined
      );
    }
  };

  const triggerLabel =
    isInvalid || !condition ? (
      <FormattedMessage id="filters.emptyCountryBorn" />
    ) : (
      <FormattedMessage id={labelKeys?.[condition]} values={{ text: sectionText }} />
    );

  return (
    <FilterSectionWrapper
      currentValue={condition}
      isDisabled={isDisabled}
      isInitialOpened={isInitialOpened}
      isInvalid={isInvalid}
      isRemovable
      onRemove={onRemove}
      onClose={resetData}
      triggerIcon={FarmIcon}
      triggerLabel={triggerLabel}
    >
      <CheckboxMenu
        options={conditions}
        onApply={handleApply}
        onConditionChange={handleConditionChange}
        currentValue={value}
      >
        {optionValue => (
          <Fragment>
            {optionValue === value && isConditionWithOptions && (
              <div className="p-10">
                <Select
                  placeholder={<FormattedMessage id="general.placeholder.searchCountryBorn" />}
                  value={COUNTRY_BORN_OPTIONS.find(option => option?.value === text)}
                  onChange={option => handleValueChange((option as OptionKeysTypes)?.value)}
                  options={COUNTRY_BORN_OPTIONS}
                  isSearchable
                  isClearable
                  isSmall
                />
              </div>
            )}
          </Fragment>
        )}
      </CheckboxMenu>
    </FilterSectionWrapper>
  );
};

export default CountryBornSection;
